/* eslint-disable */
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import log from 'common/services/logging/loggers';
import eventDebugger from 'common/services/-RFC.eventDebugger';


/**
 * Register a global subscriber callback for the TraceKit reporter
 */
angular.module('oe')
    .run(($document, Util) => {

        angular.element($document).on('click', (ev) => {

            const el = ev.target;
            const elName = `${Util.elementToStr(el.parentNode)} > ${Util.elementToStr(el)}`;

            eventDebugger.addEvent(elName);

        });

    })
    .run((Raven) => {

        if (CWCONFIG.features.debug) {

            return false;

        }

        Raven.getEvents = function () {

            const events = Mixpanel.getEvents().slice();
            Mixpanel.clearEvents();

            return events;

        };


    });

angular.module('services')
    .service('Raven', ($window) => {

        const Raven = $window.Raven;
        if (!Raven || CWCONFIG.features.debug) {

            return null;

        }

        Raven.config(CWCONFIG.debug.logServer, {}).install();

        return Raven;

    });

/**
 * Catch angular exceptions (if not in debug mode) and report them to Tracekit
 */
angular.module('services')
    .factory('$exceptionHandler', (Raven) => {

        return function (exception) {

        // exception has 3 main attributes: message, name & stack
            if (Raven && Raven.captureException && !CWCONFIG.features.debug) {

                Raven.captureException(exception, { extra: { events: eventDebugger.getEvents() } });

            } else {
                var args = (arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments));
                log.error(args);

            }

        };

    });


// WEBPACK FOOTER //
// ./scripts/common/services/exceptionHandler.js